// extracted by mini-css-extract-plugin
module.exports =  {"colorPickerItem":"ntuavi","colorPickerItemRemaining":"P5TFmm","remainingColorsCounter":"KpWcbw","separateStyles":"h26miP"};